import React from 'react';
import DashboardContent from '../../../dashboardWrapper/DashboardContent';
import Wrapper from '../../../dashboardWrapper/Wrapper';
import AllTickets from './AllTickets';

const UserTickets = () => {
  return (
    <Wrapper>
        <DashboardContent>
            <AllTickets />
        </DashboardContent>
    </Wrapper>
  )
};

export default UserTickets;
